import {
  Arrange,
  Button,
  Container,
  Spacer,
  Split,
  SplitSection,
  Text,
  TextButton,
} from '@loomhq/lens';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import * as analytics from 'utilities/analytics';

import { selectUserHasUsedAndroid, selectUserHasUsedIos } from 'selectors/user';

import {
  MOBILE_DOWNLOAD_BANNER_DISMISSED,
  MOBILE_DOWNLOAD_BANNER_GET_APP_CLICKED,
  MOBILE_DOWNLOAD_BANNER_SHOWN,
} from '../../../constants/events';

const MobileDownloadBanner = ({ onSharePage }) => {
  const [dismissed, setDismissed] = useState(false);
  const hasActivatediOS = useSelector(selectUserHasUsedIos);
  const hasActivatedAndroid = useSelector(selectUserHasUsedAndroid);

  const willShowBanner = !(dismissed || hasActivatediOS || hasActivatedAndroid);

  useEffect(() => {
    if (willShowBanner) {
      analytics.track(MOBILE_DOWNLOAD_BANNER_SHOWN, {
        onSharePage,
      });
    }
  }, [onSharePage, willShowBanner]);

  const onGetTheAppClick = () => {
    analytics.track(MOBILE_DOWNLOAD_BANNER_GET_APP_CLICKED, {
      onSharePage,
    });
    const newTab = window.open(
      'https://www.loom.com/mobile',
      '_blank',
      'noopener,noreferrer'
    );

    if (newTab) {
      newTab.opener = null;
    }
  };

  const onDismissBanner = () => {
    analytics.track(MOBILE_DOWNLOAD_BANNER_DISMISSED, {
      onSharePage,
    });

    setDismissed(true);
  };

  if (!willShowBanner) {
    return null;
  }

  return (
    <>
      <Container
        radius="medium"
        backgroundColor="highlight"
        paddingY="medium"
        paddingX="large"
      >
        <Split gap="medium" justifyContent="space-between">
          <SplitSection grow={1} basis={44}>
            <Text>
              <strong>Download the Loom mobile app</strong> to know when your
              video has been watched and interacted with on the go
            </Text>
          </SplitSection>

          <SplitSection>
            <Arrange gap="small">
              <Button variant="neutral" onClick={onGetTheAppClick}>
                Get the app
              </Button>
              <TextButton onClick={onDismissBanner}>Dismiss</TextButton>
            </Arrange>
          </SplitSection>
        </Split>
      </Container>
      <Spacer bottom="large" />
    </>
  );
};

export default MobileDownloadBanner;
